import { InitPhoneInputs, isPhoneValid } from "./classes/phoneInput.js";
import {
  submitForm,
  resetForm,
  disableForm,
  enableForm,
  showError,
  hideError,
} from "./classes/formAction.js";

var formElement = $("#email-form");
var hostname = window.location.hostname;

function initHiddenVars() {
  var url_string = window.location.href;
  var url = new URL(url_string);

  var utm_campaign = url.searchParams.get("utm_campaign");
  var utm_medium = url.searchParams.get("utm_medium");
  var utm_source = url.searchParams.get("utm_source");
  var utm_term = url.searchParams.get("utm_term");
  var utm_content = url.searchParams.get("utm_content");
  var gclid = url.searchParams.get("gclid");
  var fbclid = url.searchParams.get("fbclid");
  var msclid = url.searchParams.get("msclkid");

  document.getElementById("utm_campaign").value = utm_campaign;
  document.getElementById("utm_medium").value = utm_medium;
  document.getElementById("utm_source").value = utm_source;
  document.getElementById("utm_term").value = utm_term;
  document.getElementById("utm_content").value = utm_content;
  document.getElementById("gclid").value = gclid;
  document.getElementById("fbclid").value = fbclid;
  document.getElementById("msclid").value = msclid;

  document.getElementById("page").value = url_string.split("?")[0];
  document.getElementById("url").value = hostname;
  document.getElementById("tz").value = new Date().getTimezoneOffset();
}

function getClientIp() {
  const ipFormInput = document.getElementById("ip");

  fetch("https://api.ipify.org?format=json")
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      const ip = json.ip;
      ipFormInput.value = ip;
      ipFormInput.dispatchEvent(
        new Event("input", { bubbles: true, cancelable: true })
      );
    })
    .catch((err) => {
      console.error(`Error getting IP Address: ${err}`);
    });
}

$(function () {
  initHiddenVars();
  getClientIp();
  resetForm(formElement);

  setTimeout(() => {
    $("#dialog-wrapper").show();
    $("body").css("overflow", "hidden");
  }, 8000);

  $(".modal-open").click(function () {
    $("body").css("overflow", "hidden");
  });
  $(".scroll-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#dialog-wrapper").offset().top - 10,
      },
      1000
    );
  });
  $(".f-modal-close-link-2").click(function () {
    $("body").css("overflow", "auto");
    resetForm(formElement);
  });

  formElement.parent().removeClass("w-form");
  formElement.on("submit", function (event) {
    event.preventDefault();
    disableForm(formElement);
    hideError();

    //1. validate form number
    if (isPhoneValid()) {
      submitForm(formElement);
    } else {
      enableForm(formElement);
      showError("Numéro de téléphone invalide");
    }
  });
});

$(window).scroll(function () {
  if ($(window).scrollTop() > 0 && $(window).width() < 768) {
    // starts when browser is scrollex on the Y axis
    $("#footer_bar").addClass("logo_scrolled"); // adds the class logo_scrolled to the logo
  } else {
    // not scrolled
    $("#footer_bar").removeClass("logo_scrolled"); // removes the class logo_scrolled to the logo
  }
});
